/** The players: the brief's list in its order, less Milton (out, 13 Oct 2026), then later confirmations. Two Poojas, so the S and the J stay. */
export const BRIEF_PLAYER_NAMES: readonly string[] = [
  "Abhi", "Ani", "Ashiv", "Aswini", "Barshan", "Chandni", "Darshil", "Deepali", "Devika", "Raul",
  "Kedar", "Khushal", "Yashvi", "Krish", "Luke", "Mayuran", "Nayan", "Nikhil", "Paddy",
  "Piri", "Pooja S", "Pooja J", "Riyan", "Sam", "Shailen", "Simmi", "Stan", "Steven", "Thelaksan",
  "Thujhan", "Vinisha",
  // confirmed 5 Oct 2026, after the brief
  "Neehal",
];

/** A stable id from a name: "Pooja S" becomes "pooja-s". */
export function playerIdFor(name: string): string {
  return name.trim().toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
}

export function briefPlayers(): { id: string; name: string }[] {
  return BRIEF_PLAYER_NAMES.map((name) => ({ id: playerIdFor(name), name }));
}
